import React from 'react';

import {type RouteData} from '../types';
import {MARIMO_NOTEBOOK_EDIT_PATH} from './notebookPaths';

export const NOTEBOOK_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true,
    },
    exact: true,
    isPrivateRoute: true,
    path: MARIMO_NOTEBOOK_EDIT_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/MarimoNotebookRuntimePage')
    ),
  },
];
